import Vue from 'vue'
import App from './App'
import  router  from './router'
import 'babel-polyfill';
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import ApiService from "./services/api.service";
import TokenService  from './services/storage.service'
import '@progress/kendo-ui'
import '@progress/kendo-theme-default/dist/all.css'
import { Upload, UploadInstaller } from '@progress/kendo-upload-vue-wrapper'
import API from './config'
import VueCurrencyFilter from 'vue-currency-filter'
import '@coreui/icons'

Vue.use(VueCurrencyFilter,
    {
      symbol : 'EUR',
      thousandsSeparator: '.',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'back',
      symbolSpacing: true
    })


Vue.use(UploadInstaller)

Vue.config.performance = true
Vue.use(CoreuiVue)
//Vue.use(VeeValidate)

ApiService.init(API.URL)

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

new Vue({
  el: '#app',
  router,
  icons,
  template: '<App/>',
  store,
  components: {
    App,
    Upload
  }
})
